<<template>
  <div class="visual-page" :class="{ print: print }">
    <div>
      <table class="table" cellpadding="0" cellspacing="0">
        <tr class="header">
          <td><span v-show="print">视功能检查</span></td>
          <td> 检测值</td>
          <td>参考值</td>
          <td>训练建议</td>
        </tr>
        <tr>
          <td>四孔灯</td>
          <td>{{data.FourLight === '未测量' ? '未测量' : fourLamp[data.FourLight -2] }}</td>
          <td>2.右眼抑制 3.左眼抑制<br>4.无抑制 5.复视</td>
          <td>{{ advice.FourLight }}</td>
        </tr>
        <tr>
          <td>信噪比</td>
          <td v-html="snrValue"></td>
          <td>双眼均大于6级</td>
          <td>{{ advice.SNR }}</td>
        </tr>
        <tr>
          <td>动态知觉眼位</td>
          <td v-html="eyePositionValue"></td>
          <td>水平 ±2<br>垂直 ±1</td>
          <td>{{ advice.EyePosition }}</td>
        </tr>
        <tr>
          <td>融合</td>
          <td>{{ vergenceValue }}</td>
          <td>集合 &gt; +16 <br> 分开 &gt; -8</td>
          <td>{{ advice.Vergence }}</td>
        </tr>
        <tr>
          <td>立体视锐度</td>
          <td>{{ data.STE === '未测量' ? '未测量' : data.STE > 1200 ? '> 1200 "' : `${data.STE} "`}}</td>
          <td>&lt; 100 "</td>
          <td>{{ advice.STE }}</td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      data: {
        type: Object,
        default: null
      },
      print: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        fourLamp: ['右眼抑制', '左眼抑制', '无抑制', '复视']
      }
    },
    created() {
      console.log('visual', this.data)
    },
    computed: {
      // 训练建议
      advice() {
        return {
          FourLight: this.fourLightAdvice,
          EyePosition: this.eyePositionAdvice,
          Vergence: this.vergenceAdvice,
          STE: this.steAdvice,
          SNR: this.snrAdvice
        }
      },
      fourLightAdvice() {
        if (this.data.FourLight === 2 || this.data.FourLight === 3) {
          return '脱抑制训练'
        }
        if (this.data.FourLight === 5) {
          return '同时视训练'
        }
        return ''
      },
      eyePositionAdvice() {
        if (
          this.data.EyePosition.x === '未测量' ||
          this.data.EyePosition.y === '未测量'
        ) {
          return ''
        }
        if (
          this.data.EyePosition.x >= -5 &&
          this.data.EyePosition.x <= 5 &&
          (this.data.EyePosition.y >= -3 && this.data.EyePosition.y <= 3)
        ) {
          return ''
        } else {
          return '同时视训练 + 融合训练'
        }
      },
      vergenceAdvice() {
        if (this.data.Vergence === '未测量') {
          return ''
        }
        const [max, min] = [this.data.Vergence.BI[1], this.data.Vergence.BO[1]]
        return min > -6 || max < 16 ? '融合训练' : ''
      },
      steAdvice() {
        if (this.data.STE === '未测量') {
          return ''
        }
        return this.data.STE >= 100 ? '立体视训练+融合训练' : ''
      },
      snrAdvice() {
        console.log(this.data.SNR, 'snr')
        if (this.data.SNR.OD === '未测量' && this.data.SNR.OS === '未测量') {
          return ''
        }
        if (
          Math.abs(this.data.SNR.OD - this.data.SNR.OS) > 2 ||
          this.data.SNR.OD < 6 ||
          this.data.SNR.OS < 6
        ) {
          return '脱抑制训练'
        }
        // if (this.data.SNR.OD < 6 || this.data.SNR.OS < 6) {
        //   return '融合训练'
        // }
      },
      // 信噪比
      snrValue() {
        if (this.data.SNR.OS === '未测量') {
          return '未测量'
        }
        return `右眼: ${this.data.SNR.OD}级 <br />
        左眼: ${this.data.SNR.OS}级`
      },
      // 动态知觉眼位
      eyePositionValue() {
        if (
          this.data.EyePosition.x === '未测量' ||
          this.data.EyePosition.y === '未测量'
        ) {
          return '未测量'
        }
        return `水平: ${this.data.EyePosition.x} <br />
          垂直: ${this.data.EyePosition.y}`
      },
      vergenceValue() {
        if (this.data.Vergence === '未测量') {
          console.log('vergence未测量')
          return '未测量'
        }
        return this.data.Vergence.BI[1] + '~' + this.data.Vergence.BO[1]
      },
    }
  }
</script>

<style scoped lang="scss">
.visual-page {
  min-height: 30vh;
  // height: 30vh;
  .table {
    width: 100%;
    padding: 10px;
    tr {
      line-height: 36px;
      padding: 2px;
      &.header {
        font-size: 16px;
        td {
          border-bottom: 1px solid #fff;
        }
      }
      td {
        width: 25%;
        text-align: center;
        font-size: 15px;
        border-bottom: 1px solid #525050;
      }
    }
    
  }
    
  
}
</style>